import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  Stack,
} from "@mui/material";
import { motion } from "framer-motion";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";


import calidad from "../../assets/img/calidad.png";
import birrete from "../../assets/img/birrete.png";
import idea from "../../assets/img/idea.png";
import lista from "../../assets/img/lista.png";
import LogoColegio from "../../assets/img/gris.png";

const cards = [
  {
    titulo: "DESARROLLO INTEGRAL",
    descripcion:
      "Formamos estudiantes en todas sus dimensiones: académica, emocional, social y física.",
    imagen: calidad,
    color: "#484a75",
  },
  {
    titulo: "AÑOS EN LA EDUCACIÓN",
    descripcion:
      "Más de 25 años acompañando a familias en el proceso educativo de nuestros estudiantes.",
    imagen: birrete,
    color: "#8f1515",
  },
  {
    titulo: "VALORES EN LA COMUNIDAD",
    descripcion:
      "Promovemos valores cristianos que fortalecen la convivencia y el respeto.",
    imagen: idea,
    color: "#484a75",
  },
  {
    titulo: "INFRAESTRUCTURA NECESARIA",
    descripcion:
      "Contamos con espacios adecuados y seguros para el aprendizaje.",
    imagen: lista,
    color: "#8f1515",
  },
];

const valores = [
  {
    nombre: "Fe",
    icono: <FavoriteBorderIcon />,
  },
  {
    nombre: "Respeto",
    icono: <HandshakeOutlinedIcon />,
  },
  {
    nombre: "Responsabilidad",
    icono: <AssignmentIcon />,
  },
  {
    nombre: "Solidaridad",
    icono: <VolunteerActivismOutlinedIcon />,
  },
  {
    nombre: "Excelencia",
    icono: <EmojiEventsOutlinedIcon />,
  },
];

export const Administracion = () => {
    const fadeUp = {
  hidden: {
    opacity: 0,
    y: 70,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -80,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
    },
  },
};

const fadeRight = {
  hidden: {
    opacity: 0,
    x: 80,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1,
    },
  },
};

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
    },
  },
};
  return (
    <Box
      sx={{
        py: 10,
        background: "#fff",
      }}
    >
      <Container maxWidth="xl">
        <Typography
         component={motion.h2}
  initial={{
    opacity: 0,
    y: -40,
  }}
  whileInView={{
    opacity: 1,
    y: 0,
  }}
  viewport={{ once: true }}
  transition={{
    duration: 0.8,
  }}
          align="center"
          sx={{
            fontFamily:'Archivo',
            fontWeight: 700,
            color: "#484a75",
            fontSize: {
              xs: "2rem",
              md: "2.8rem",
            },
            mb: 6,
          }}
        >
          ¿POR QUÉ ELEGIRNOS?
        </Typography>

          <Grid
   container
  spacing={4}
  component={motion.div}
  variants={container}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.2 }}
  sx={{
    position: "relative",
    mt: 2,
  }}
>   
          {cards.map((item) => (
            <Grid component={motion.div}
  variants={fadeUp}
  size={{ xs: 12, md: 6, lg: 3 }} key={item.titulo}>
              <Card
               component={motion.div}
  whileHover={{
    y: -10,
    scale: 1.03,
  }}
  transition={{
    duration: .35,
  }}
                elevation={0}
                sx={{
                  p: 4,
                  borderRadius: "22px",
                  border: "1px solid #e8edf5",
                  height: "100%",
                  transition: ".35s",
                 
                  

                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 20px 40px rgba(0,0,0,.08)",
                  },
                }}
              >
                <Stack spacing={3} sx={{ display:'flex',
                  alignItems:'center',
                  justifyContent:'center',
                  flexDirection:'column',}}>
                  <Box
    component={motion.div}
  animate={{
    y: [0, -6, 0],
  }}
  whileHover={{
    rotate: 360,
    scale: 1.15,
  }}
  transition={{
    y: {
      duration: 2.8,
      repeat: Infinity,
    },
    rotate: {
      duration: .8,
    },
  }}
    sx={{
        width: 82,
        height: 82,
        borderRadius: "50%",
        background: item.color,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: `0 10px 30px ${item.color}55`,
    }}
>
    <Box
       
        component={motion.img}
variants={fadeLeft}
initial="hidden"
whileInView="visible"
viewport={{ once: true }}
        src={item.imagen}
        alt={item.titulo}
        sx={{
            width: 70,
            height: 70,
            objectFit: "contain",
            filter: "brightness(0) invert(1)",
        }}
    />
</Box>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: "#484a75",
                      fontSize:{xs:'1rem', md:"1.5rem", lg:"1.5rem"},
                      textAlign:'center',
                      lineHeight:1,
                       fontFamily:'Archivo',
                       mb:-2
                    }}
                  >
                    {item.titulo}
                  </Typography>
 <Box
    sx={{
      width: 65,          // Largo del subrayado
      height: 3,
      bgcolor: "#C62828",
      borderRadius: "10px",
      
    }}
  />
                  <Typography
                    sx={{
                      color: "#666",
                      lineHeight: 1.4,
                      fontFamily:'Archivo',
                      textAlign:'center'
                    }}
                  >
                    {item.descripcion}
                  </Typography>
                </Stack>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* SECCION INFERIOR */}

      <Box
  component={motion.div}
  variants={fadeRight}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
  sx={{
    mt: 8,
    borderRadius: "30px",
    overflow: "hidden",
    position: "relative",
    background: "linear-gradient(135deg,#484a75 0%, #3f4168 100%)",
    p: {
      xs: 4,
      md: 7,
    },
  }}
>
  {/* Marca de agua opcional */}
  <Box
    component="img"
    src={LogoColegio}
    sx={{
      position: "absolute",
      right: -40,
      top: "50%",
      transform: "translateY(-50%)",
      width: 320,
      opacity: 0.04,
      pointerEvents: "none",
    }}
  />

  <Grid container spacing={6} alignItems="center">

    {/* Texto */}
    <Grid size={{ xs: 12, md: 8 }}>

      <Typography
        sx={{
          color: "#c69ba5",
          fontWeight: 700,
          letterSpacing: 2,
          mb: 1,
        }}
      >
        NUESTRA MISIÓN
      </Typography>

      <Box
        sx={{
          width: 80,
          height: 3,
          bgcolor: "#e3effb",
          borderRadius: 5,
          mb: 3,
        }}
      />

      <Typography
        sx={{
          color: "#fff",
          fontWeight: 700,
          fontFamily: "Archivo",
          fontSize: {
            xs: "2rem",
            md: "3rem",
          },
          lineHeight: 1.1,
          mb: 3,
        }}
      >
        Formar con excelencia
      </Typography>

      <Typography
        sx={{
          color: "#dfe7f5",
          fontSize: {
            xs: "1rem",
            md: "1.2rem",
          },
          lineHeight: 1.8,
          maxWidth: 700,
        }}
      >
        En nuestro establecimiento buscamos entregar una educación de calidad
        que fortalezca el desarrollo académico, humano y espiritual de cada
        estudiante, promoviendo principios y valores que les permitan enfrentar
        los desafíos del futuro con responsabilidad, compromiso y vocación de
        servicio.
      </Typography>

    </Grid>

    {/* Valores */}
    <Grid
      size={{ xs: 12, md: 4 }}
      sx={{
        borderLeft: {
          xs: "none",
          md: "2px solid rgba(255,255,255,.15)",
        },
        pl: {
          xs: 0,
          md: 4,
        },
      }}
    >
      <Stack spacing={2.5}>
        {valores.map((valor) => (
          <Stack
            component={motion.div}
            key={valor.nombre}
            direction="row"
            spacing={2}
            whileHover={{ x: 8 }}
            transition={{ duration: .25 }}
            alignItems="center"
            sx={{
              py: 1.2,
              borderBottom: "1px solid rgba(255,255,255,.12)",
            }}
          >
            <Box
              sx={{
                width: 52,
                height: 52,
                borderRadius: "50%",
                bgcolor: "rgba(255,255,255,.08)",
                border: "2px solid #c69ba5",
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {valor.icono}
            </Box>

            <Typography
              sx={{
                color: "#fff",
                fontWeight: 600,
                fontSize: "1.1rem",
                fontFamily: "Archivo",
              }}
            >
              {valor.nombre}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Grid>

  </Grid>
</Box>
      </Container>
    </Box>
  );
};